import { render, staticRenderFns } from "./ReportExtrato.vue?vue&type=template&id=7d52b140&"
import script from "./ReportExtrato.vue?vue&type=script&lang=js&"
export * from "./ReportExtrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports